var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"fire",style:({
    width: (_vm.level + "%")
  }),attrs:{"src":require("@/assets/fire.png")}})}
var staticRenderFns = []

export { render, staticRenderFns }